import { FocusMonitor, _IdGenerator, FocusKeyManager } from '@angular/cdk/a11y';
import { ENTER, SPACE, BACKSPACE, DELETE, TAB, hasModifierKey, UP_ARROW, DOWN_ARROW } from '@angular/cdk/keycodes';
import { _CdkPrivateStyleLoader, _VisuallyHiddenLoader } from '@angular/cdk/private';
import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, inject, ElementRef, booleanAttribute, numberAttribute, Directive, Input, ChangeDetectorRef, NgZone, EventEmitter, Injector, ANIMATION_MODULE_TYPE, Component, ViewEncapsulation, ChangeDetectionStrategy, ContentChildren, Output, ContentChild, ViewChild, afterNextRender, QueryList, forwardRef, NgModule } from '@angular/core';
import { _StructuralStylesLoader, MAT_RIPPLE_GLOBAL_OPTIONS, MatRippleLoader, ErrorStateMatcher, _ErrorStateTracker, MatCommonModule, MatRippleModule } from '@angular/material/core';
import { Subject, merge } from 'rxjs';
import { takeUntil, startWith, switchMap } from 'rxjs/operators';
import { Directionality } from '@angular/cdk/bidi';
import { NG_VALUE_ACCESSOR, NgControl, Validators, NgForm, FormGroupDirective } from '@angular/forms';
import { MatFormFieldControl, MAT_FORM_FIELD } from '@angular/material/form-field';

/** Injection token to be used to override the default options for the chips module. */
const _c0 = ["*", [["mat-chip-avatar"], ["", "matChipAvatar", ""]], [["mat-chip-trailing-icon"], ["", "matChipRemove", ""], ["", "matChipTrailingIcon", ""]]];
const _c1 = ["*", "mat-chip-avatar, [matChipAvatar]", "mat-chip-trailing-icon,[matChipRemove],[matChipTrailingIcon]"];
function MatChip_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function MatChip_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function MatChipOption_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 9);
    i0.ɵɵelement(4, "path", 10);
    i0.ɵɵelementEnd()()();
  }
}
function MatChipOption_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
const _c2 = ".mdc-evolution-chip,.mdc-evolution-chip__cell,.mdc-evolution-chip__action{display:inline-flex;align-items:center}.mdc-evolution-chip{position:relative;max-width:100%}.mdc-evolution-chip__cell,.mdc-evolution-chip__action{height:100%}.mdc-evolution-chip__cell--primary{flex-basis:100%;overflow-x:hidden}.mdc-evolution-chip__cell--trailing{flex:1 0 auto}.mdc-evolution-chip__action{align-items:center;background:none;border:none;box-sizing:content-box;cursor:pointer;display:inline-flex;justify-content:center;outline:none;padding:0;text-decoration:none;color:inherit}.mdc-evolution-chip__action--presentational{cursor:auto}.mdc-evolution-chip--disabled,.mdc-evolution-chip__action:disabled{pointer-events:none}.mdc-evolution-chip__action--primary{font:inherit;letter-spacing:inherit;white-space:inherit;overflow-x:hidden}.mat-mdc-standard-chip .mdc-evolution-chip__action--primary::before{border-width:var(--mdc-chip-outline-width, 1px);border-radius:var(--mdc-chip-container-shape-radius, 8px);box-sizing:border-box;content:\"\";height:100%;left:0;position:absolute;pointer-events:none;top:0;width:100%;z-index:1;border-style:solid}.mat-mdc-standard-chip .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:12px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:0;padding-right:12px}[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:0}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--primary::before{border-color:var(--mdc-chip-outline-color, var(--mat-sys-outline))}.mdc-evolution-chip__action--primary:not(.mdc-evolution-chip__action--presentational):not(.mdc-ripple-upgraded):focus::before{border-color:var(--mdc-chip-focus-outline-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--primary::before{border-color:var(--mdc-chip-disabled-outline-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent))}.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__action--primary::before{border-width:var(--mdc-chip-flat-selected-outline-width, 0)}.mat-mdc-basic-chip .mdc-evolution-chip__action--primary{font:inherit}.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:0}[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:12px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:0;padding-right:12px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:0}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}.mdc-evolution-chip__action--trailing{position:relative;overflow:visible}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--trailing{color:var(--mdc-chip-with-trailing-icon-trailing-icon-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--trailing{color:var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-color, var(--mat-sys-on-surface))}.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}.mdc-evolution-chip__text-label{-webkit-user-select:none;user-select:none;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.mat-mdc-standard-chip .mdc-evolution-chip__text-label{font-family:var(--mdc-chip-label-text-font, var(--mat-sys-label-large-font));line-height:var(--mdc-chip-label-text-line-height, var(--mat-sys-label-large-line-height));font-size:var(--mdc-chip-label-text-size, var(--mat-sys-label-large-size));font-weight:var(--mdc-chip-label-text-weight, var(--mat-sys-label-large-weight));letter-spacing:var(--mdc-chip-label-text-tracking, var(--mat-sys-label-large-tracking))}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label{color:var(--mdc-chip-label-text-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label{color:var(--mdc-chip-selected-label-text-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label,.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label{color:var(--mdc-chip-disabled-label-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.mdc-evolution-chip__graphic{align-items:center;display:inline-flex;justify-content:center;overflow:hidden;pointer-events:none;position:relative;flex:1 0 auto}.mat-mdc-standard-chip .mdc-evolution-chip__graphic{width:var(--mdc-chip-with-avatar-avatar-size, 24px);height:var(--mdc-chip-with-avatar-avatar-size, 24px);font-size:var(--mdc-chip-with-avatar-avatar-size, 24px)}.mdc-evolution-chip--selecting .mdc-evolution-chip__graphic{transition:width 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-evolution-chip--selectable:not(.mdc-evolution-chip--selected):not(.mdc-evolution-chip--with-primary-icon) .mdc-evolution-chip__graphic{width:0}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic{padding-left:6px;padding-right:6px}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic{padding-left:4px;padding-right:8px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic{padding-left:8px;padding-right:4px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic{padding-left:6px;padding-right:6px}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic{padding-left:4px;padding-right:8px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic{padding-left:8px;padding-right:4px}.mdc-evolution-chip__checkmark{position:absolute;opacity:0;top:50%;left:50%;height:20px;width:20px}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__checkmark{color:var(--mdc-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__checkmark{color:var(--mdc-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface))}.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark{transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);transform:translate(-75%, -50%)}.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark{transform:translate(-50%, -50%);opacity:1}.mdc-evolution-chip__checkmark-svg{display:block}.mdc-evolution-chip__checkmark-path{stroke-width:2px;stroke-dasharray:29.7833385;stroke-dashoffset:29.7833385;stroke:currentColor}.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark-path{transition:stroke-dashoffset 150ms 45ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark-path{stroke-dashoffset:0}@media(forced-colors: active){.mdc-evolution-chip__checkmark-path{stroke:CanvasText !important}}.mat-mdc-standard-chip .mdc-evolution-chip__icon--trailing{height:18px;width:18px;font-size:18px}.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove{opacity:calc(var(--mat-chip-trailing-action-opacity, 1)*var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38))}.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove:focus{opacity:calc(var(--mat-chip-trailing-action-focus-opacity, 1)*var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38))}.mat-mdc-standard-chip{border-radius:var(--mdc-chip-container-shape-radius, 8px);height:var(--mdc-chip-container-height, 32px)}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled){background-color:var(--mdc-chip-elevated-container-color, transparent)}.mat-mdc-standard-chip.mdc-evolution-chip--disabled{background-color:var(--mdc-chip-elevated-disabled-container-color)}.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled){background-color:var(--mdc-chip-elevated-selected-container-color, var(--mat-sys-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled{background-color:var(--mdc-chip-flat-disabled-selected-container-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent))}@media(forced-colors: active){.mat-mdc-standard-chip{outline:solid 1px}}.mat-mdc-standard-chip .mdc-evolution-chip__icon--primary{border-radius:var(--mdc-chip-with-avatar-avatar-shape-radius, 24px);width:var(--mdc-chip-with-icon-icon-size, 18px);height:var(--mdc-chip-with-icon-icon-size, 18px);font-size:var(--mdc-chip-with-icon-icon-size, 18px)}.mdc-evolution-chip--selected .mdc-evolution-chip__icon--primary{opacity:0}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__icon--primary{color:var(--mdc-chip-with-icon-icon-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--primary{color:var(--mdc-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface))}.mat-mdc-chip-highlighted{--mdc-chip-with-icon-icon-color:var(--mdc-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container));--mdc-chip-elevated-container-color:var(--mdc-chip-elevated-selected-container-color, var(--mat-sys-secondary-container));--mdc-chip-label-text-color:var(--mdc-chip-selected-label-text-color, var(--mat-sys-on-secondary-container));--mdc-chip-outline-width:var(--mdc-chip-flat-selected-outline-width, 0)}.mat-mdc-chip-focus-overlay{background:var(--mdc-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant))}.mat-mdc-chip-selected .mat-mdc-chip-focus-overlay,.mat-mdc-chip-highlighted .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container))}.mat-mdc-chip:hover .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-hover-state-layer-color, var(--mat-sys-on-surface-variant));opacity:var(--mdc-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity))}.mat-mdc-chip-focus-overlay .mat-mdc-chip-selected:hover,.mat-mdc-chip-highlighted:hover .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-selected-hover-state-layer-color, var(--mat-sys-on-secondary-container));opacity:var(--mdc-chip-selected-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity))}.mat-mdc-chip.cdk-focused .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant));opacity:var(--mdc-chip-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity))}.mat-mdc-chip-selected.cdk-focused .mat-mdc-chip-focus-overlay,.mat-mdc-chip-highlighted.cdk-focused .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container));opacity:var(--mdc-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity))}.mdc-evolution-chip--disabled:not(.mdc-evolution-chip--selected) .mat-mdc-chip-avatar{opacity:var(--mdc-chip-with-avatar-disabled-avatar-opacity, 0.38)}.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing{opacity:var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38)}.mdc-evolution-chip--disabled.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark{opacity:var(--mdc-chip-with-icon-disabled-icon-opacity, 0.38)}.mat-mdc-standard-chip.mdc-evolution-chip--disabled{opacity:var(--mat-chip-disabled-container-opacity, 1)}.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__icon--trailing,.mat-mdc-standard-chip.mat-mdc-chip-highlighted .mdc-evolution-chip__icon--trailing{color:var(--mat-chip-selected-trailing-icon-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing,.mat-mdc-standard-chip.mat-mdc-chip-highlighted.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing{color:var(--mat-chip-selected-disabled-trailing-icon-color, var(--mat-sys-on-surface))}.mat-mdc-chip-remove{opacity:var(--mat-chip-trailing-action-opacity, 1)}.mat-mdc-chip-remove:focus{opacity:var(--mat-chip-trailing-action-focus-opacity, 1)}.mat-mdc-chip-remove::after{background-color:var(--mat-chip-trailing-action-state-layer-color, var(--mat-sys-on-surface-variant))}.mat-mdc-chip-remove:hover::after{opacity:var(--mat-chip-trailing-action-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity))}.mat-mdc-chip-remove:focus::after{opacity:var(--mat-chip-trailing-action-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity))}.mat-mdc-chip-selected .mat-mdc-chip-remove::after,.mat-mdc-chip-highlighted .mat-mdc-chip-remove::after{background-color:var(--mat-chip-selected-trailing-action-state-layer-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip{-webkit-tap-highlight-color:rgba(0,0,0,0)}.mat-mdc-standard-chip .mdc-evolution-chip__cell--primary,.mat-mdc-standard-chip .mdc-evolution-chip__action--primary,.mat-mdc-standard-chip .mat-mdc-chip-action-label{overflow:visible}.mat-mdc-standard-chip .mat-mdc-chip-graphic,.mat-mdc-standard-chip .mat-mdc-chip-trailing-icon{box-sizing:content-box}.mat-mdc-standard-chip._mat-animation-noopable,.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__graphic,.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark,.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark-path{transition-duration:1ms;animation-duration:1ms}.mat-mdc-chip-focus-overlay{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;opacity:0;border-radius:inherit;transition:opacity 150ms linear}._mat-animation-noopable .mat-mdc-chip-focus-overlay{transition:none}.mat-mdc-basic-chip .mat-mdc-chip-focus-overlay{display:none}.mat-mdc-chip .mat-ripple.mat-mdc-chip-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-mdc-chip-avatar{text-align:center;line-height:1;color:var(--mdc-chip-with-icon-icon-color, currentColor)}.mat-mdc-chip{position:relative;z-index:0}.mat-mdc-chip-action-label{text-align:left;z-index:1}[dir=rtl] .mat-mdc-chip-action-label{text-align:right}.mat-mdc-chip.mdc-evolution-chip--with-trailing-action .mat-mdc-chip-action-label{position:relative}.mat-mdc-chip-action-label .mat-mdc-chip-primary-focus-indicator{position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none}.mat-mdc-chip-action-label .mat-focus-indicator::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 2px)*-1)}.mat-mdc-chip-remove::before{margin:calc(var(--mat-focus-indicator-border-width, 3px)*-1);left:8px;right:8px}.mat-mdc-chip-remove::after{content:\"\";display:block;opacity:0;position:absolute;top:-3px;bottom:-3px;left:5px;right:5px;border-radius:50%;box-sizing:border-box;padding:12px;margin:-12px;background-clip:content-box}.mat-mdc-chip-remove .mat-icon{width:18px;height:18px;font-size:18px;box-sizing:content-box}.mat-chip-edit-input{cursor:text;display:inline-block;color:inherit;outline:0}@media(forced-colors: active){.mat-mdc-chip-selected:not(.mat-mdc-chip-multiple){outline-width:3px}}.mat-mdc-chip-action:focus .mat-focus-indicator::before{content:\"\"}";
const _c3 = [[["mat-chip-avatar"], ["", "matChipAvatar", ""]], [["", "matChipEditInput", ""]], "*", [["mat-chip-trailing-icon"], ["", "matChipRemove", ""], ["", "matChipTrailingIcon", ""]]];
const _c4 = ["mat-chip-avatar, [matChipAvatar]", "[matChipEditInput]", "*", "mat-chip-trailing-icon,[matChipRemove],[matChipTrailingIcon]"];
function MatChipRow_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
}
function MatChipRow_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function MatChipRow_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function MatChipRow_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
}
function MatChipRow_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MatChipRow_Conditional_4_Conditional_0_Template, 1, 0)(1, MatChipRow_Conditional_4_Conditional_1_Template, 1, 0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.contentEditInput ? 0 : 1);
  }
}
function MatChipRow_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function MatChipRow_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵelementEnd();
  }
}
const _c5 = ["*"];
const _c6 = ".mat-mdc-chip-set{display:flex}.mat-mdc-chip-set:focus{outline:none}.mat-mdc-chip-set .mdc-evolution-chip-set__chips{min-width:100%;margin-left:-8px;margin-right:0}.mat-mdc-chip-set .mdc-evolution-chip{margin:4px 0 4px 8px}[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip-set__chips{margin-left:0;margin-right:-8px}[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip{margin-left:0;margin-right:8px}.mdc-evolution-chip-set__chips{display:flex;flex-flow:wrap;min-width:0}.mat-mdc-chip-set-stacked{flex-direction:column;align-items:flex-start}.mat-mdc-chip-set-stacked .mat-mdc-chip{width:100%}.mat-mdc-chip-set-stacked .mdc-evolution-chip__graphic{flex-grow:0}.mat-mdc-chip-set-stacked .mdc-evolution-chip__action--primary{flex-basis:100%;justify-content:start}input.mat-mdc-chip-input{flex:1 0 150px;margin-left:8px}[dir=rtl] input.mat-mdc-chip-input{margin-left:0;margin-right:8px}";
const MAT_CHIPS_DEFAULT_OPTIONS = /*#__PURE__*/new InjectionToken('mat-chips-default-options', {
  providedIn: 'root',
  factory: () => ({
    separatorKeyCodes: [ENTER]
  })
});
/**
 * Injection token that can be used to reference instances of `MatChipAvatar`. It serves as
 * alternative token to the actual `MatChipAvatar` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
const MAT_CHIP_AVATAR = /*#__PURE__*/new InjectionToken('MatChipAvatar');
/**
 * Injection token that can be used to reference instances of `MatChipTrailingIcon`. It serves as
 * alternative token to the actual `MatChipTrailingIcon` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
const MAT_CHIP_TRAILING_ICON = /*#__PURE__*/new InjectionToken('MatChipTrailingIcon');
/**
 * Injection token that can be used to reference instances of `MatChipRemove`. It serves as
 * alternative token to the actual `MatChipRemove` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
const MAT_CHIP_REMOVE = /*#__PURE__*/new InjectionToken('MatChipRemove');
/**
 * Injection token used to avoid a circular dependency between the `MatChip` and `MatChipAction`.
 */
const MAT_CHIP = /*#__PURE__*/new InjectionToken('MatChip');

/**
 * Section within a chip.
 * @docs-private
 */
let MatChipAction = /*#__PURE__*/(() => {
  class MatChipAction {
    _elementRef = inject(ElementRef);
    _parentChip = inject(MAT_CHIP);
    /** Whether the action is interactive. */
    isInteractive = true;
    /** Whether this is the primary action in the chip. */
    _isPrimary = true;
    /** Whether the action is disabled. */
    get disabled() {
      return this._disabled || this._parentChip?.disabled || false;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled = false;
    /** Tab index of the action. */
    tabIndex = -1;
    /**
     * Private API to allow focusing this chip when it is disabled.
     */
    _allowFocusWhenDisabled = false;
    /**
     * Determine the value of the disabled attribute for this chip action.
     */
    _getDisabledAttribute() {
      // When this chip action is disabled and focusing disabled chips is not permitted, return empty
      // string to indicate that disabled attribute should be included.
      return this.disabled && !this._allowFocusWhenDisabled ? '' : null;
    }
    /**
     * Determine the value of the tabindex attribute for this chip action.
     */
    _getTabindex() {
      return this.disabled && !this._allowFocusWhenDisabled || !this.isInteractive ? null : this.tabIndex.toString();
    }
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_StructuralStylesLoader);
      if (this._elementRef.nativeElement.nodeName === 'BUTTON') {
        this._elementRef.nativeElement.setAttribute('type', 'button');
      }
    }
    focus() {
      this._elementRef.nativeElement.focus();
    }
    _handleClick(event) {
      if (!this.disabled && this.isInteractive && this._isPrimary) {
        event.preventDefault();
        this._parentChip._handlePrimaryActionInteraction();
      }
    }
    _handleKeydown(event) {
      if ((event.keyCode === ENTER || event.keyCode === SPACE) && !this.disabled && this.isInteractive && this._isPrimary && !this._parentChip._isEditing) {
        event.preventDefault();
        this._parentChip._handlePrimaryActionInteraction();
      }
    }
    static ɵfac = function MatChipAction_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipAction)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipAction,
      selectors: [["", "matChipAction", ""]],
      hostAttrs: [1, "mdc-evolution-chip__action", "mat-mdc-chip-action"],
      hostVars: 9,
      hostBindings: function MatChipAction_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function MatChipAction_click_HostBindingHandler($event) {
            return ctx._handleClick($event);
          })("keydown", function MatChipAction_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx._getTabindex())("disabled", ctx._getDisabledAttribute())("aria-disabled", ctx.disabled);
          i0.ɵɵclassProp("mdc-evolution-chip__action--primary", ctx._isPrimary)("mdc-evolution-chip__action--presentational", !ctx.isInteractive)("mdc-evolution-chip__action--trailing", !ctx._isPrimary);
        }
      },
      inputs: {
        isInteractive: "isInteractive",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        tabIndex: [2, "tabIndex", "tabIndex", value => value == null ? -1 : numberAttribute(value)],
        _allowFocusWhenDisabled: "_allowFocusWhenDisabled"
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return MatChipAction;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Avatar image within a chip. */
let MatChipAvatar = /*#__PURE__*/(() => {
  class MatChipAvatar {
    static ɵfac = function MatChipAvatar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipAvatar)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipAvatar,
      selectors: [["mat-chip-avatar"], ["", "matChipAvatar", ""]],
      hostAttrs: ["role", "img", 1, "mat-mdc-chip-avatar", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--primary"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_AVATAR,
        useExisting: MatChipAvatar
      }])]
    });
  }
  return MatChipAvatar;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** Non-interactive trailing icon in a chip. */
let MatChipTrailingIcon = /*#__PURE__*/(() => {
  class MatChipTrailingIcon extends MatChipAction {
    /**
     * MDC considers all trailing actions as a remove icon,
     * but we support non-interactive trailing icons.
     */
    isInteractive = false;
    _isPrimary = false;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipTrailingIcon_BaseFactory;
      return function MatChipTrailingIcon_Factory(__ngFactoryType__) {
        return (ɵMatChipTrailingIcon_BaseFactory || (ɵMatChipTrailingIcon_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipTrailingIcon)))(__ngFactoryType__ || MatChipTrailingIcon);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipTrailingIcon,
      selectors: [["mat-chip-trailing-icon"], ["", "matChipTrailingIcon", ""]],
      hostAttrs: ["aria-hidden", "true", 1, "mat-mdc-chip-trailing-icon", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--trailing"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_TRAILING_ICON,
        useExisting: MatChipTrailingIcon
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatChipTrailingIcon;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Directive to remove the parent chip when the trailing icon is clicked or
 * when the ENTER key is pressed on it.
 *
 * Recommended for use with the Material Design "cancel" icon
 * available at https://material.io/icons/#ic_cancel.
 *
 * Example:
 *
 * ```
 * <mat-chip>
 *   <mat-icon matChipRemove>cancel</mat-icon>
 * </mat-chip>
 * ```
 */
let MatChipRemove = /*#__PURE__*/(() => {
  class MatChipRemove extends MatChipAction {
    _isPrimary = false;
    _handleClick(event) {
      if (!this.disabled) {
        event.stopPropagation();
        event.preventDefault();
        this._parentChip.remove();
      }
    }
    _handleKeydown(event) {
      if ((event.keyCode === ENTER || event.keyCode === SPACE) && !this.disabled) {
        event.stopPropagation();
        event.preventDefault();
        this._parentChip.remove();
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipRemove_BaseFactory;
      return function MatChipRemove_Factory(__ngFactoryType__) {
        return (ɵMatChipRemove_BaseFactory || (ɵMatChipRemove_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipRemove)))(__ngFactoryType__ || MatChipRemove);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipRemove,
      selectors: [["", "matChipRemove", ""]],
      hostAttrs: ["role", "button", 1, "mat-mdc-chip-remove", "mat-mdc-chip-trailing-icon", "mat-focus-indicator", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--trailing"],
      hostVars: 1,
      hostBindings: function MatChipRemove_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-hidden", null);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_REMOVE,
        useExisting: MatChipRemove
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatChipRemove;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Material design styled Chip base component. Used inside the MatChipSet component.
 *
 * Extended by MatChipOption and MatChipRow for different interaction patterns.
 */
let MatChip = /*#__PURE__*/(() => {
  class MatChip {
    _changeDetectorRef = inject(ChangeDetectorRef);
    _elementRef = inject(ElementRef);
    _ngZone = inject(NgZone);
    _focusMonitor = inject(FocusMonitor);
    _globalRippleOptions = inject(MAT_RIPPLE_GLOBAL_OPTIONS, {
      optional: true
    });
    _document = inject(DOCUMENT);
    /** Emits when the chip is focused. */
    _onFocus = new Subject();
    /** Emits when the chip is blurred. */
    _onBlur = new Subject();
    /** Whether this chip is a basic (unstyled) chip. */
    _isBasicChip;
    /** Role for the root of the chip. */
    role = null;
    /** Whether the chip has focus. */
    _hasFocusInternal = false;
    /** Whether moving focus into the chip is pending. */
    _pendingFocus;
    /** Subscription to changes in the chip's actions. */
    _actionChanges;
    /** Whether animations for the chip are enabled. */
    _animationsDisabled;
    /** All avatars present in the chip. */
    _allLeadingIcons;
    /** All trailing icons present in the chip. */
    _allTrailingIcons;
    /** All remove icons present in the chip. */
    _allRemoveIcons;
    _hasFocus() {
      return this._hasFocusInternal;
    }
    /** A unique id for the chip. If none is supplied, it will be auto-generated. */
    id = inject(_IdGenerator).getId('mat-mdc-chip-');
    // TODO(#26104): Consider deprecating and using `_computeAriaAccessibleName` instead.
    // `ariaLabel` may be unnecessary, and `_computeAriaAccessibleName` only supports
    // datepicker's use case.
    /** ARIA label for the content of the chip. */
    ariaLabel = null;
    // TODO(#26104): Consider deprecating and using `_computeAriaAccessibleName` instead.
    // `ariaDescription` may be unnecessary, and `_computeAriaAccessibleName` only supports
    // datepicker's use case.
    /** ARIA description for the content of the chip. */
    ariaDescription = null;
    /** Id of a span that contains this chip's aria description. */
    _ariaDescriptionId = `${this.id}-aria-description`;
    /** Whether the chip list is disabled. */
    _chipListDisabled = false;
    _textElement;
    /**
     * The value of the chip. Defaults to the content inside
     * the `mat-mdc-chip-action-label` element.
     */
    get value() {
      return this._value !== undefined ? this._value : this._textElement.textContent.trim();
    }
    set value(value) {
      this._value = value;
    }
    _value;
    // TODO: should be typed as `ThemePalette` but internal apps pass in arbitrary strings.
    /**
     * Theme color of the chip. This API is supported in M2 themes only, it has no
     * effect in M3 themes. For color customization in M3, see https://material.angular.io/components/chips/styling.
     *
     * For information on applying color variants in M3, see
     * https://material.angular.io/guide/material-2-theming#optional-add-backwards-compatibility-styles-for-color-variants
     */
    color;
    /**
     * Determines whether or not the chip displays the remove styling and emits (removed) events.
     */
    removable = true;
    /**
     * Colors the chip for emphasis as if it were selected.
     */
    highlighted = false;
    /** Whether the ripple effect is disabled or not. */
    disableRipple = false;
    /** Whether the chip is disabled. */
    get disabled() {
      return this._disabled || this._chipListDisabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled = false;
    /** Emitted when a chip is to be removed. */
    removed = new EventEmitter();
    /** Emitted when the chip is destroyed. */
    destroyed = new EventEmitter();
    /** The unstyled chip selector for this component. */
    basicChipAttrName = 'mat-basic-chip';
    /** The chip's leading icon. */
    leadingIcon;
    /** The chip's trailing icon. */
    trailingIcon;
    /** The chip's trailing remove icon. */
    removeIcon;
    /** Action receiving the primary set of user interactions. */
    primaryAction;
    /**
     * Handles the lazy creation of the MatChip ripple.
     * Used to improve initial load time of large applications.
     */
    _rippleLoader = inject(MatRippleLoader);
    _injector = inject(Injector);
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_StructuralStylesLoader);
      inject(_CdkPrivateStyleLoader).load(_VisuallyHiddenLoader);
      const animationMode = inject(ANIMATION_MODULE_TYPE, {
        optional: true
      });
      this._animationsDisabled = animationMode === 'NoopAnimations';
      this._monitorFocus();
      this._rippleLoader?.configureRipple(this._elementRef.nativeElement, {
        className: 'mat-mdc-chip-ripple',
        disabled: this._isRippleDisabled()
      });
    }
    ngOnInit() {
      // This check needs to happen in `ngOnInit` so the overridden value of
      // `basicChipAttrName` coming from base classes can be picked up.
      const element = this._elementRef.nativeElement;
      this._isBasicChip = element.hasAttribute(this.basicChipAttrName) || element.tagName.toLowerCase() === this.basicChipAttrName;
    }
    ngAfterViewInit() {
      this._textElement = this._elementRef.nativeElement.querySelector('.mat-mdc-chip-action-label');
      if (this._pendingFocus) {
        this._pendingFocus = false;
        this.focus();
      }
    }
    ngAfterContentInit() {
      // Since the styling depends on the presence of some
      // actions, we have to mark for check on changes.
      this._actionChanges = merge(this._allLeadingIcons.changes, this._allTrailingIcons.changes, this._allRemoveIcons.changes).subscribe(() => this._changeDetectorRef.markForCheck());
    }
    ngDoCheck() {
      this._rippleLoader.setDisabled(this._elementRef.nativeElement, this._isRippleDisabled());
    }
    ngOnDestroy() {
      this._focusMonitor.stopMonitoring(this._elementRef);
      this._rippleLoader?.destroyRipple(this._elementRef.nativeElement);
      this._actionChanges?.unsubscribe();
      this.destroyed.emit({
        chip: this
      });
      this.destroyed.complete();
    }
    /**
     * Allows for programmatic removal of the chip.
     *
     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
     */
    remove() {
      if (this.removable) {
        this.removed.emit({
          chip: this
        });
      }
    }
    /** Whether or not the ripple should be disabled. */
    _isRippleDisabled() {
      return this.disabled || this.disableRipple || this._animationsDisabled || this._isBasicChip || !!this._globalRippleOptions?.disabled;
    }
    /** Returns whether the chip has a trailing icon. */
    _hasTrailingIcon() {
      return !!(this.trailingIcon || this.removeIcon);
    }
    /** Handles keyboard events on the chip. */
    _handleKeydown(event) {
      // Ignore backspace events where the user is holding down the key
      // so that we don't accidentally remove too many chips.
      if (event.keyCode === BACKSPACE && !event.repeat || event.keyCode === DELETE) {
        event.preventDefault();
        this.remove();
      }
    }
    /** Allows for programmatic focusing of the chip. */
    focus() {
      if (!this.disabled) {
        // If `focus` is called before `ngAfterViewInit`, we won't have access to the primary action.
        // This can happen if the consumer tries to focus a chip immediately after it is added.
        // Queue the method to be called again on init.
        if (this.primaryAction) {
          this.primaryAction.focus();
        } else {
          this._pendingFocus = true;
        }
      }
    }
    /** Gets the action that contains a specific target node. */
    _getSourceAction(target) {
      return this._getActions().find(action => {
        const element = action._elementRef.nativeElement;
        return element === target || element.contains(target);
      });
    }
    /** Gets all of the actions within the chip. */
    _getActions() {
      const result = [];
      if (this.primaryAction) {
        result.push(this.primaryAction);
      }
      if (this.removeIcon) {
        result.push(this.removeIcon);
      }
      if (this.trailingIcon) {
        result.push(this.trailingIcon);
      }
      return result;
    }
    /** Handles interactions with the primary action of the chip. */
    _handlePrimaryActionInteraction() {
      // Empty here, but is overwritten in child classes.
    }
    /** Starts the focus monitoring process on the chip. */
    _monitorFocus() {
      this._focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
        const hasFocus = origin !== null;
        if (hasFocus !== this._hasFocusInternal) {
          this._hasFocusInternal = hasFocus;
          if (hasFocus) {
            this._onFocus.next({
              chip: this
            });
          } else {
            // When animations are enabled, Angular may end up removing the chip from the DOM a little
            // earlier than usual, causing it to be blurred and throwing off the logic in the chip list
            // that moves focus to the next item. To work around the issue, we defer marking the chip
            // as not focused until after the next render.
            this._changeDetectorRef.markForCheck();
            setTimeout(() => this._ngZone.run(() => this._onBlur.next({
              chip: this
            })));
          }
        }
      });
    }
    static ɵfac = function MatChip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChip)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChip,
      selectors: [["mat-basic-chip"], ["", "mat-basic-chip", ""], ["mat-chip"], ["", "mat-chip", ""]],
      contentQueries: function MatChip_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_AVATAR, 5);
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_TRAILING_ICON, 5);
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_REMOVE, 5);
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_AVATAR, 5);
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_TRAILING_ICON, 5);
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_REMOVE, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leadingIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trailingIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.removeIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allLeadingIcons = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allTrailingIcons = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allRemoveIcons = _t);
        }
      },
      viewQuery: function MatChip_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatChipAction, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.primaryAction = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-chip"],
      hostVars: 31,
      hostBindings: function MatChip_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MatChip_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id);
          i0.ɵɵattribute("role", ctx.role)("aria-label", ctx.ariaLabel);
          i0.ɵɵclassMap("mat-" + (ctx.color || "primary"));
          i0.ɵɵclassProp("mdc-evolution-chip", !ctx._isBasicChip)("mdc-evolution-chip--disabled", ctx.disabled)("mdc-evolution-chip--with-trailing-action", ctx._hasTrailingIcon())("mdc-evolution-chip--with-primary-graphic", ctx.leadingIcon)("mdc-evolution-chip--with-primary-icon", ctx.leadingIcon)("mdc-evolution-chip--with-avatar", ctx.leadingIcon)("mat-mdc-chip-with-avatar", ctx.leadingIcon)("mat-mdc-chip-highlighted", ctx.highlighted)("mat-mdc-chip-disabled", ctx.disabled)("mat-mdc-basic-chip", ctx._isBasicChip)("mat-mdc-standard-chip", !ctx._isBasicChip)("mat-mdc-chip-with-trailing-icon", ctx._hasTrailingIcon())("_mat-animation-noopable", ctx._animationsDisabled);
        }
      },
      inputs: {
        role: "role",
        id: "id",
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaDescription: [0, "aria-description", "ariaDescription"],
        value: "value",
        color: "color",
        removable: [2, "removable", "removable", booleanAttribute],
        highlighted: [2, "highlighted", "highlighted", booleanAttribute],
        disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        removed: "removed",
        destroyed: "destroyed"
      },
      exportAs: ["matChip"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP,
        useExisting: MatChip
      }]), i0.ɵɵInputTransformsFeature],
      ngContentSelectors: _c1,
      decls: 8,
      vars: 3,
      consts: [[1, "mat-mdc-chip-focus-overlay"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--primary"], ["matChipAction", "", 3, "isInteractive"], [1, "mdc-evolution-chip__graphic", "mat-mdc-chip-graphic"], [1, "mdc-evolution-chip__text-label", "mat-mdc-chip-action-label"], [1, "mat-mdc-chip-primary-focus-indicator", "mat-focus-indicator"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--trailing"]],
      template: function MatChip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵelement(0, "span", 0);
          i0.ɵɵelementStart(1, "span", 1)(2, "span", 2);
          i0.ɵɵtemplate(3, MatChip_Conditional_3_Template, 2, 0, "span", 3);
          i0.ɵɵelementStart(4, "span", 4);
          i0.ɵɵprojection(5);
          i0.ɵɵelement(6, "span", 5);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(7, MatChip_Conditional_7_Template, 2, 0, "span", 6);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("isInteractive", false);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.leadingIcon ? 3 : -1);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx._hasTrailingIcon() ? 7 : -1);
        }
      },
      dependencies: [MatChipAction],
      styles: [".mdc-evolution-chip,.mdc-evolution-chip__cell,.mdc-evolution-chip__action{display:inline-flex;align-items:center}.mdc-evolution-chip{position:relative;max-width:100%}.mdc-evolution-chip__cell,.mdc-evolution-chip__action{height:100%}.mdc-evolution-chip__cell--primary{flex-basis:100%;overflow-x:hidden}.mdc-evolution-chip__cell--trailing{flex:1 0 auto}.mdc-evolution-chip__action{align-items:center;background:none;border:none;box-sizing:content-box;cursor:pointer;display:inline-flex;justify-content:center;outline:none;padding:0;text-decoration:none;color:inherit}.mdc-evolution-chip__action--presentational{cursor:auto}.mdc-evolution-chip--disabled,.mdc-evolution-chip__action:disabled{pointer-events:none}.mdc-evolution-chip__action--primary{font:inherit;letter-spacing:inherit;white-space:inherit;overflow-x:hidden}.mat-mdc-standard-chip .mdc-evolution-chip__action--primary::before{border-width:var(--mdc-chip-outline-width, 1px);border-radius:var(--mdc-chip-container-shape-radius, 8px);box-sizing:border-box;content:\"\";height:100%;left:0;position:absolute;pointer-events:none;top:0;width:100%;z-index:1;border-style:solid}.mat-mdc-standard-chip .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:12px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:0;padding-right:12px}[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:0}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--primary::before{border-color:var(--mdc-chip-outline-color, var(--mat-sys-outline))}.mdc-evolution-chip__action--primary:not(.mdc-evolution-chip__action--presentational):not(.mdc-ripple-upgraded):focus::before{border-color:var(--mdc-chip-focus-outline-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--primary::before{border-color:var(--mdc-chip-disabled-outline-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent))}.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__action--primary::before{border-width:var(--mdc-chip-flat-selected-outline-width, 0)}.mat-mdc-basic-chip .mdc-evolution-chip__action--primary{font:inherit}.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:0}[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:12px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:0;padding-right:12px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary{padding-left:12px;padding-right:0}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary{padding-left:0;padding-right:0}.mdc-evolution-chip__action--trailing{position:relative;overflow:visible}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--trailing{color:var(--mdc-chip-with-trailing-icon-trailing-icon-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--trailing{color:var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-color, var(--mat-sys-on-surface))}.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--trailing{padding-left:8px;padding-right:8px}.mdc-evolution-chip__text-label{-webkit-user-select:none;user-select:none;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.mat-mdc-standard-chip .mdc-evolution-chip__text-label{font-family:var(--mdc-chip-label-text-font, var(--mat-sys-label-large-font));line-height:var(--mdc-chip-label-text-line-height, var(--mat-sys-label-large-line-height));font-size:var(--mdc-chip-label-text-size, var(--mat-sys-label-large-size));font-weight:var(--mdc-chip-label-text-weight, var(--mat-sys-label-large-weight));letter-spacing:var(--mdc-chip-label-text-tracking, var(--mat-sys-label-large-tracking))}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label{color:var(--mdc-chip-label-text-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label{color:var(--mdc-chip-selected-label-text-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label,.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label{color:var(--mdc-chip-disabled-label-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.mdc-evolution-chip__graphic{align-items:center;display:inline-flex;justify-content:center;overflow:hidden;pointer-events:none;position:relative;flex:1 0 auto}.mat-mdc-standard-chip .mdc-evolution-chip__graphic{width:var(--mdc-chip-with-avatar-avatar-size, 24px);height:var(--mdc-chip-with-avatar-avatar-size, 24px);font-size:var(--mdc-chip-with-avatar-avatar-size, 24px)}.mdc-evolution-chip--selecting .mdc-evolution-chip__graphic{transition:width 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-evolution-chip--selectable:not(.mdc-evolution-chip--selected):not(.mdc-evolution-chip--with-primary-icon) .mdc-evolution-chip__graphic{width:0}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic{padding-left:6px;padding-right:6px}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic{padding-left:4px;padding-right:8px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic{padding-left:8px;padding-right:4px}.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic{padding-left:6px;padding-right:6px}.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic{padding-left:4px;padding-right:8px}[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic{padding-left:8px;padding-right:4px}.mdc-evolution-chip__checkmark{position:absolute;opacity:0;top:50%;left:50%;height:20px;width:20px}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__checkmark{color:var(--mdc-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__checkmark{color:var(--mdc-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface))}.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark{transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);transform:translate(-75%, -50%)}.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark{transform:translate(-50%, -50%);opacity:1}.mdc-evolution-chip__checkmark-svg{display:block}.mdc-evolution-chip__checkmark-path{stroke-width:2px;stroke-dasharray:29.7833385;stroke-dashoffset:29.7833385;stroke:currentColor}.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark-path{transition:stroke-dashoffset 150ms 45ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark-path{stroke-dashoffset:0}@media(forced-colors: active){.mdc-evolution-chip__checkmark-path{stroke:CanvasText !important}}.mat-mdc-standard-chip .mdc-evolution-chip__icon--trailing{height:18px;width:18px;font-size:18px}.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove{opacity:calc(var(--mat-chip-trailing-action-opacity, 1)*var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38))}.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove:focus{opacity:calc(var(--mat-chip-trailing-action-focus-opacity, 1)*var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38))}.mat-mdc-standard-chip{border-radius:var(--mdc-chip-container-shape-radius, 8px);height:var(--mdc-chip-container-height, 32px)}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled){background-color:var(--mdc-chip-elevated-container-color, transparent)}.mat-mdc-standard-chip.mdc-evolution-chip--disabled{background-color:var(--mdc-chip-elevated-disabled-container-color)}.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled){background-color:var(--mdc-chip-elevated-selected-container-color, var(--mat-sys-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled{background-color:var(--mdc-chip-flat-disabled-selected-container-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent))}@media(forced-colors: active){.mat-mdc-standard-chip{outline:solid 1px}}.mat-mdc-standard-chip .mdc-evolution-chip__icon--primary{border-radius:var(--mdc-chip-with-avatar-avatar-shape-radius, 24px);width:var(--mdc-chip-with-icon-icon-size, 18px);height:var(--mdc-chip-with-icon-icon-size, 18px);font-size:var(--mdc-chip-with-icon-icon-size, 18px)}.mdc-evolution-chip--selected .mdc-evolution-chip__icon--primary{opacity:0}.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__icon--primary{color:var(--mdc-chip-with-icon-icon-color, var(--mat-sys-on-surface-variant))}.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--primary{color:var(--mdc-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface))}.mat-mdc-chip-highlighted{--mdc-chip-with-icon-icon-color:var(--mdc-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container));--mdc-chip-elevated-container-color:var(--mdc-chip-elevated-selected-container-color, var(--mat-sys-secondary-container));--mdc-chip-label-text-color:var(--mdc-chip-selected-label-text-color, var(--mat-sys-on-secondary-container));--mdc-chip-outline-width:var(--mdc-chip-flat-selected-outline-width, 0)}.mat-mdc-chip-focus-overlay{background:var(--mdc-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant))}.mat-mdc-chip-selected .mat-mdc-chip-focus-overlay,.mat-mdc-chip-highlighted .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container))}.mat-mdc-chip:hover .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-hover-state-layer-color, var(--mat-sys-on-surface-variant));opacity:var(--mdc-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity))}.mat-mdc-chip-focus-overlay .mat-mdc-chip-selected:hover,.mat-mdc-chip-highlighted:hover .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-selected-hover-state-layer-color, var(--mat-sys-on-secondary-container));opacity:var(--mdc-chip-selected-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity))}.mat-mdc-chip.cdk-focused .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant));opacity:var(--mdc-chip-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity))}.mat-mdc-chip-selected.cdk-focused .mat-mdc-chip-focus-overlay,.mat-mdc-chip-highlighted.cdk-focused .mat-mdc-chip-focus-overlay{background:var(--mdc-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container));opacity:var(--mdc-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity))}.mdc-evolution-chip--disabled:not(.mdc-evolution-chip--selected) .mat-mdc-chip-avatar{opacity:var(--mdc-chip-with-avatar-disabled-avatar-opacity, 0.38)}.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing{opacity:var(--mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38)}.mdc-evolution-chip--disabled.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark{opacity:var(--mdc-chip-with-icon-disabled-icon-opacity, 0.38)}.mat-mdc-standard-chip.mdc-evolution-chip--disabled{opacity:var(--mat-chip-disabled-container-opacity, 1)}.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__icon--trailing,.mat-mdc-standard-chip.mat-mdc-chip-highlighted .mdc-evolution-chip__icon--trailing{color:var(--mat-chip-selected-trailing-icon-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing,.mat-mdc-standard-chip.mat-mdc-chip-highlighted.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing{color:var(--mat-chip-selected-disabled-trailing-icon-color, var(--mat-sys-on-surface))}.mat-mdc-chip-remove{opacity:var(--mat-chip-trailing-action-opacity, 1)}.mat-mdc-chip-remove:focus{opacity:var(--mat-chip-trailing-action-focus-opacity, 1)}.mat-mdc-chip-remove::after{background-color:var(--mat-chip-trailing-action-state-layer-color, var(--mat-sys-on-surface-variant))}.mat-mdc-chip-remove:hover::after{opacity:var(--mat-chip-trailing-action-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity))}.mat-mdc-chip-remove:focus::after{opacity:var(--mat-chip-trailing-action-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity))}.mat-mdc-chip-selected .mat-mdc-chip-remove::after,.mat-mdc-chip-highlighted .mat-mdc-chip-remove::after{background-color:var(--mat-chip-selected-trailing-action-state-layer-color, var(--mat-sys-on-secondary-container))}.mat-mdc-standard-chip{-webkit-tap-highlight-color:rgba(0,0,0,0)}.mat-mdc-standard-chip .mdc-evolution-chip__cell--primary,.mat-mdc-standard-chip .mdc-evolution-chip__action--primary,.mat-mdc-standard-chip .mat-mdc-chip-action-label{overflow:visible}.mat-mdc-standard-chip .mat-mdc-chip-graphic,.mat-mdc-standard-chip .mat-mdc-chip-trailing-icon{box-sizing:content-box}.mat-mdc-standard-chip._mat-animation-noopable,.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__graphic,.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark,.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark-path{transition-duration:1ms;animation-duration:1ms}.mat-mdc-chip-focus-overlay{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;opacity:0;border-radius:inherit;transition:opacity 150ms linear}._mat-animation-noopable .mat-mdc-chip-focus-overlay{transition:none}.mat-mdc-basic-chip .mat-mdc-chip-focus-overlay{display:none}.mat-mdc-chip .mat-ripple.mat-mdc-chip-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-mdc-chip-avatar{text-align:center;line-height:1;color:var(--mdc-chip-with-icon-icon-color, currentColor)}.mat-mdc-chip{position:relative;z-index:0}.mat-mdc-chip-action-label{text-align:left;z-index:1}[dir=rtl] .mat-mdc-chip-action-label{text-align:right}.mat-mdc-chip.mdc-evolution-chip--with-trailing-action .mat-mdc-chip-action-label{position:relative}.mat-mdc-chip-action-label .mat-mdc-chip-primary-focus-indicator{position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none}.mat-mdc-chip-action-label .mat-focus-indicator::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 2px)*-1)}.mat-mdc-chip-remove::before{margin:calc(var(--mat-focus-indicator-border-width, 3px)*-1);left:8px;right:8px}.mat-mdc-chip-remove::after{content:\"\";display:block;opacity:0;position:absolute;top:-3px;bottom:-3px;left:5px;right:5px;border-radius:50%;box-sizing:border-box;padding:12px;margin:-12px;background-clip:content-box}.mat-mdc-chip-remove .mat-icon{width:18px;height:18px;font-size:18px;box-sizing:content-box}.mat-chip-edit-input{cursor:text;display:inline-block;color:inherit;outline:0}@media(forced-colors: active){.mat-mdc-chip-selected:not(.mat-mdc-chip-multiple){outline-width:3px}}.mat-mdc-chip-action:focus .mat-focus-indicator::before{content:\"\"}"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatChip;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Event object emitted by MatChipOption when selected or deselected. */
class MatChipSelectionChange {
  source;
  selected;
  isUserInput;
  constructor(/** Reference to the chip that emitted the event. */
  source, /** Whether the chip that emitted the event is selected. */
  selected, /** Whether the selection change was a result of a user interaction. */
  isUserInput = false) {
    this.source = source;
    this.selected = selected;
    this.isUserInput = isUserInput;
  }
}
/**
 * An extension of the MatChip component that supports chip selection. Used with MatChipListbox.
 *
 * Unlike other chips, the user can focus on disabled chip options inside a MatChipListbox. The
 * user cannot click disabled chips.
 */
let MatChipOption = /*#__PURE__*/(() => {
  class MatChipOption extends MatChip {
    /** Default chip options. */
    _defaultOptions = inject(MAT_CHIPS_DEFAULT_OPTIONS, {
      optional: true
    });
    /** Whether the chip list is selectable. */
    chipListSelectable = true;
    /** Whether the chip list is in multi-selection mode. */
    _chipListMultiple = false;
    /** Whether the chip list hides single-selection indicator. */
    _chipListHideSingleSelectionIndicator = this._defaultOptions?.hideSingleSelectionIndicator ?? false;
    /**
     * Whether or not the chip is selectable.
     *
     * When a chip is not selectable, changes to its selected state are always
     * ignored. By default an option chip is selectable, and it becomes
     * non-selectable if its parent chip list is not selectable.
     */
    get selectable() {
      return this._selectable && this.chipListSelectable;
    }
    set selectable(value) {
      this._selectable = value;
      this._changeDetectorRef.markForCheck();
    }
    _selectable = true;
    /** Whether the chip is selected. */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      this._setSelectedState(value, false, true);
    }
    _selected = false;
    /**
     * The ARIA selected applied to the chip. Conforms to WAI ARIA best practices for listbox
     * interaction patterns.
     *
     * From [WAI ARIA Listbox authoring practices guide](
     * https://www.w3.org/WAI/ARIA/apg/patterns/listbox/):
     *  "If any options are selected, each selected option has either aria-selected or aria-checked
     *  set to true. All options that are selectable but not selected have either aria-selected or
     *  aria-checked set to false."
     *
     * Set `aria-selected="false"` on not-selected listbox options that are selectable to fix
     * VoiceOver reading every option as "selected" (#25736).
     */
    get ariaSelected() {
      return this.selectable ? this.selected.toString() : null;
    }
    /** The unstyled chip selector for this component. */
    basicChipAttrName = 'mat-basic-chip-option';
    /** Emitted when the chip is selected or deselected. */
    selectionChange = new EventEmitter();
    ngOnInit() {
      super.ngOnInit();
      this.role = 'presentation';
    }
    /** Selects the chip. */
    select() {
      this._setSelectedState(true, false, true);
    }
    /** Deselects the chip. */
    deselect() {
      this._setSelectedState(false, false, true);
    }
    /** Selects this chip and emits userInputSelection event */
    selectViaInteraction() {
      this._setSelectedState(true, true, true);
    }
    /** Toggles the current selected state of this chip. */
    toggleSelected(isUserInput = false) {
      this._setSelectedState(!this.selected, isUserInput, true);
      return this.selected;
    }
    _handlePrimaryActionInteraction() {
      if (!this.disabled) {
        // Interacting with the primary action implies that the chip already has focus, however
        // there's a bug in Safari where focus ends up lingering on the previous chip (see #27544).
        // We work around it by explicitly focusing the primary action of the current chip.
        this.focus();
        if (this.selectable) {
          this.toggleSelected(true);
        }
      }
    }
    _hasLeadingGraphic() {
      if (this.leadingIcon) {
        return true;
      }
      // The checkmark graphic communicates selected state for both single-select and multi-select.
      // Include checkmark in single-select to fix a11y issue where selected state is communicated
      // visually only using color (#25886).
      return !this._chipListHideSingleSelectionIndicator || this._chipListMultiple;
    }
    _setSelectedState(isSelected, isUserInput, emitEvent) {
      if (isSelected !== this.selected) {
        this._selected = isSelected;
        if (emitEvent) {
          this.selectionChange.emit({
            source: this,
            isUserInput,
            selected: this.selected
          });
        }
        this._changeDetectorRef.markForCheck();
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipOption_BaseFactory;
      return function MatChipOption_Factory(__ngFactoryType__) {
        return (ɵMatChipOption_BaseFactory || (ɵMatChipOption_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipOption)))(__ngFactoryType__ || MatChipOption);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipOption,
      selectors: [["mat-basic-chip-option"], ["", "mat-basic-chip-option", ""], ["mat-chip-option"], ["", "mat-chip-option", ""]],
      hostAttrs: [1, "mat-mdc-chip", "mat-mdc-chip-option"],
      hostVars: 37,
      hostBindings: function MatChipOption_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id);
          i0.ɵɵattribute("tabindex", null)("aria-label", null)("aria-description", null)("role", ctx.role);
          i0.ɵɵclassProp("mdc-evolution-chip", !ctx._isBasicChip)("mdc-evolution-chip--filter", !ctx._isBasicChip)("mdc-evolution-chip--selectable", !ctx._isBasicChip)("mat-mdc-chip-selected", ctx.selected)("mat-mdc-chip-multiple", ctx._chipListMultiple)("mat-mdc-chip-disabled", ctx.disabled)("mat-mdc-chip-with-avatar", ctx.leadingIcon)("mdc-evolution-chip--disabled", ctx.disabled)("mdc-evolution-chip--selected", ctx.selected)("mdc-evolution-chip--selecting", !ctx._animationsDisabled)("mdc-evolution-chip--with-trailing-action", ctx._hasTrailingIcon())("mdc-evolution-chip--with-primary-icon", ctx.leadingIcon)("mdc-evolution-chip--with-primary-graphic", ctx._hasLeadingGraphic())("mdc-evolution-chip--with-avatar", ctx.leadingIcon)("mat-mdc-chip-highlighted", ctx.highlighted)("mat-mdc-chip-with-trailing-icon", ctx._hasTrailingIcon());
        }
      },
      inputs: {
        selectable: [2, "selectable", "selectable", booleanAttribute],
        selected: [2, "selected", "selected", booleanAttribute]
      },
      outputs: {
        selectionChange: "selectionChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatChip,
        useExisting: MatChipOption
      }, {
        provide: MAT_CHIP,
        useExisting: MatChipOption
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 10,
      vars: 8,
      consts: [[1, "mat-mdc-chip-focus-overlay"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--primary"], ["matChipAction", "", "role", "option", 3, "_allowFocusWhenDisabled"], [1, "mdc-evolution-chip__graphic", "mat-mdc-chip-graphic"], [1, "mdc-evolution-chip__text-label", "mat-mdc-chip-action-label"], [1, "mat-mdc-chip-primary-focus-indicator", "mat-focus-indicator"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--trailing"], [1, "cdk-visually-hidden", 3, "id"], [1, "mdc-evolution-chip__checkmark"], ["viewBox", "-2 -3 30 30", "focusable", "false", "aria-hidden", "true", 1, "mdc-evolution-chip__checkmark-svg"], ["fill", "none", "stroke", "currentColor", "d", "M1.73,12.91 8.1,19.28 22.79,4.59", 1, "mdc-evolution-chip__checkmark-path"]],
      template: function MatChipOption_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵelement(0, "span", 0);
          i0.ɵɵelementStart(1, "span", 1)(2, "button", 2);
          i0.ɵɵtemplate(3, MatChipOption_Conditional_3_Template, 5, 0, "span", 3);
          i0.ɵɵelementStart(4, "span", 4);
          i0.ɵɵprojection(5);
          i0.ɵɵelement(6, "span", 5);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(7, MatChipOption_Conditional_7_Template, 2, 0, "span", 6);
          i0.ɵɵelementStart(8, "span", 7);
          i0.ɵɵtext(9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("_allowFocusWhenDisabled", true);
          i0.ɵɵattribute("aria-selected", ctx.ariaSelected)("aria-label", ctx.ariaLabel)("aria-describedby", ctx._ariaDescriptionId);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx._hasLeadingGraphic() ? 3 : -1);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx._hasTrailingIcon() ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx._ariaDescriptionId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.ariaDescription);
        }
      },
      dependencies: [MatChipAction],
      styles: [_c2],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatChipOption;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A directive that makes a span editable and exposes functions to modify and retrieve the
 * element's contents.
 */
let MatChipEditInput = /*#__PURE__*/(() => {
  class MatChipEditInput {
    _elementRef = inject(ElementRef);
    _document = inject(DOCUMENT);
    constructor() {}
    initialize(initialValue) {
      this.getNativeElement().focus();
      this.setValue(initialValue);
    }
    getNativeElement() {
      return this._elementRef.nativeElement;
    }
    setValue(value) {
      this.getNativeElement().textContent = value;
      this._moveCursorToEndOfInput();
    }
    getValue() {
      return this.getNativeElement().textContent || '';
    }
    _moveCursorToEndOfInput() {
      const range = this._document.createRange();
      range.selectNodeContents(this.getNativeElement());
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    static ɵfac = function MatChipEditInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipEditInput)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipEditInput,
      selectors: [["span", "matChipEditInput", ""]],
      hostAttrs: ["role", "textbox", "tabindex", "-1", "contenteditable", "true", 1, "mat-chip-edit-input"]
    });
  }
  return MatChipEditInput;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * An extension of the MatChip component used with MatChipGrid and
 * the matChipInputFor directive.
 */
let MatChipRow = /*#__PURE__*/(() => {
  class MatChipRow extends MatChip {
    basicChipAttrName = 'mat-basic-chip-row';
    /**
     * The editing action has to be triggered in a timeout. While we're waiting on it, a blur
     * event might occur which will interrupt the editing. This flag is used to avoid interruptions
     * while the editing action is being initialized.
     */
    _editStartPending = false;
    editable = false;
    /** Emitted when the chip is edited. */
    edited = new EventEmitter();
    /** The default chip edit input that is used if none is projected into this chip row. */
    defaultEditInput;
    /** The projected chip edit input. */
    contentEditInput;
    _isEditing = false;
    constructor() {
      super();
      this.role = 'row';
      this._onBlur.pipe(takeUntil(this.destroyed)).subscribe(() => {
        if (this._isEditing && !this._editStartPending) {
          this._onEditFinish();
        }
      });
    }
    _hasTrailingIcon() {
      // The trailing icon is hidden while editing.
      return !this._isEditing && super._hasTrailingIcon();
    }
    /** Sends focus to the first gridcell when the user clicks anywhere inside the chip. */
    _handleFocus() {
      if (!this._isEditing && !this.disabled) {
        this.focus();
      }
    }
    _handleKeydown(event) {
      if (event.keyCode === ENTER && !this.disabled) {
        if (this._isEditing) {
          event.preventDefault();
          this._onEditFinish();
        } else if (this.editable) {
          this._startEditing(event);
        }
      } else if (this._isEditing) {
        // Stop the event from reaching the chip set in order to avoid navigating.
        event.stopPropagation();
      } else {
        super._handleKeydown(event);
      }
    }
    _handleDoubleclick(event) {
      if (!this.disabled && this.editable) {
        this._startEditing(event);
      }
    }
    _startEditing(event) {
      if (!this.primaryAction || this.removeIcon && this._getSourceAction(event.target) === this.removeIcon) {
        return;
      }
      // The value depends on the DOM so we need to extract it before we flip the flag.
      const value = this.value;
      this._isEditing = this._editStartPending = true;
      // Defer initializing the input until after it has been added to the DOM.
      afterNextRender(() => {
        this._getEditInput().initialize(value);
        this._editStartPending = false;
      }, {
        injector: this._injector
      });
    }
    _onEditFinish() {
      this._isEditing = this._editStartPending = false;
      this.edited.emit({
        chip: this,
        value: this._getEditInput().getValue()
      });
      // If the edit input is still focused or focus was returned to the body after it was destroyed,
      // return focus to the chip contents.
      if (this._document.activeElement === this._getEditInput().getNativeElement() || this._document.activeElement === this._document.body) {
        this.primaryAction.focus();
      }
    }
    _isRippleDisabled() {
      return super._isRippleDisabled() || this._isEditing;
    }
    /**
     * Gets the projected chip edit input, or the default input if none is projected in. One of these
     * two values is guaranteed to be defined.
     */
    _getEditInput() {
      return this.contentEditInput || this.defaultEditInput;
    }
    static ɵfac = function MatChipRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipRow)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipRow,
      selectors: [["mat-chip-row"], ["", "mat-chip-row", ""], ["mat-basic-chip-row"], ["", "mat-basic-chip-row", ""]],
      contentQueries: function MatChipRow_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChipEditInput, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentEditInput = _t.first);
        }
      },
      viewQuery: function MatChipRow_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatChipEditInput, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultEditInput = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-chip", "mat-mdc-chip-row", "mdc-evolution-chip"],
      hostVars: 27,
      hostBindings: function MatChipRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatChipRow_focus_HostBindingHandler($event) {
            return ctx._handleFocus($event);
          })("dblclick", function MatChipRow_dblclick_HostBindingHandler($event) {
            return ctx._handleDoubleclick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id);
          i0.ɵɵattribute("tabindex", ctx.disabled ? null : -1)("aria-label", null)("aria-description", null)("role", ctx.role);
          i0.ɵɵclassProp("mat-mdc-chip-with-avatar", ctx.leadingIcon)("mat-mdc-chip-disabled", ctx.disabled)("mat-mdc-chip-editing", ctx._isEditing)("mat-mdc-chip-editable", ctx.editable)("mdc-evolution-chip--disabled", ctx.disabled)("mdc-evolution-chip--with-trailing-action", ctx._hasTrailingIcon())("mdc-evolution-chip--with-primary-graphic", ctx.leadingIcon)("mdc-evolution-chip--with-primary-icon", ctx.leadingIcon)("mdc-evolution-chip--with-avatar", ctx.leadingIcon)("mat-mdc-chip-highlighted", ctx.highlighted)("mat-mdc-chip-with-trailing-icon", ctx._hasTrailingIcon());
        }
      },
      inputs: {
        editable: "editable"
      },
      outputs: {
        edited: "edited"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatChip,
        useExisting: MatChipRow
      }, {
        provide: MAT_CHIP,
        useExisting: MatChipRow
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c4,
      decls: 10,
      vars: 9,
      consts: [[1, "mat-mdc-chip-focus-overlay"], ["role", "gridcell", "matChipAction", "", 1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--primary", 3, "disabled"], [1, "mdc-evolution-chip__graphic", "mat-mdc-chip-graphic"], [1, "mdc-evolution-chip__text-label", "mat-mdc-chip-action-label"], ["aria-hidden", "true", 1, "mat-mdc-chip-primary-focus-indicator", "mat-focus-indicator"], ["role", "gridcell", 1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--trailing"], [1, "cdk-visually-hidden", 3, "id"], ["matChipEditInput", ""]],
      template: function MatChipRow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵtemplate(0, MatChipRow_Conditional_0_Template, 1, 0, "span", 0);
          i0.ɵɵelementStart(1, "span", 1);
          i0.ɵɵtemplate(2, MatChipRow_Conditional_2_Template, 2, 0, "span", 2);
          i0.ɵɵelementStart(3, "span", 3);
          i0.ɵɵtemplate(4, MatChipRow_Conditional_4_Template, 2, 1)(5, MatChipRow_Conditional_5_Template, 1, 0);
          i0.ɵɵelement(6, "span", 4);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, MatChipRow_Conditional_7_Template, 2, 0, "span", 5);
          i0.ɵɵelementStart(8, "span", 6);
          i0.ɵɵtext(9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx._isEditing ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵattribute("aria-label", ctx.ariaLabel)("aria-describedby", ctx._ariaDescriptionId);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.leadingIcon ? 2 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx._isEditing ? 4 : 5);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx._hasTrailingIcon() ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx._ariaDescriptionId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.ariaDescription);
        }
      },
      dependencies: [MatChipAction, MatChipEditInput],
      styles: [_c2],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatChipRow;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Basic container component for the MatChip component.
 *
 * Extended by MatChipListbox and MatChipGrid for different interaction patterns.
 */
let MatChipSet = /*#__PURE__*/(() => {
  class MatChipSet {
    _elementRef = inject(ElementRef);
    _changeDetectorRef = inject(ChangeDetectorRef);
    _dir = inject(Directionality, {
      optional: true
    });
    /** Index of the last destroyed chip that had focus. */
    _lastDestroyedFocusedChipIndex = null;
    /** Used to manage focus within the chip list. */
    _keyManager;
    /** Subject that emits when the component has been destroyed. */
    _destroyed = new Subject();
    /** Role to use if it hasn't been overwritten by the user. */
    _defaultRole = 'presentation';
    /** Combined stream of all of the child chips' focus events. */
    get chipFocusChanges() {
      return this._getChipStream(chip => chip._onFocus);
    }
    /** Combined stream of all of the child chips' destroy events. */
    get chipDestroyedChanges() {
      return this._getChipStream(chip => chip.destroyed);
    }
    /** Combined stream of all of the child chips' remove events. */
    get chipRemovedChanges() {
      return this._getChipStream(chip => chip.removed);
    }
    /** Whether the chip set is disabled. */
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
      this._syncChipsState();
    }
    _disabled = false;
    /** Whether the chip list contains chips or not. */
    get empty() {
      return !this._chips || this._chips.length === 0;
    }
    /** The ARIA role applied to the chip set. */
    get role() {
      if (this._explicitRole) {
        return this._explicitRole;
      }
      return this.empty ? null : this._defaultRole;
    }
    /** Tabindex of the chip set. */
    tabIndex = 0;
    set role(value) {
      this._explicitRole = value;
    }
    _explicitRole = null;
    /** Whether any of the chips inside of this chip-set has focus. */
    get focused() {
      return this._hasFocusedChip();
    }
    /** The chips that are part of this chip set. */
    _chips;
    /** Flat list of all the actions contained within the chips. */
    _chipActions = new QueryList();
    constructor() {}
    ngAfterViewInit() {
      this._setUpFocusManagement();
      this._trackChipSetChanges();
      this._trackDestroyedFocusedChip();
    }
    ngOnDestroy() {
      this._keyManager?.destroy();
      this._chipActions.destroy();
      this._destroyed.next();
      this._destroyed.complete();
    }
    /** Checks whether any of the chips is focused. */
    _hasFocusedChip() {
      return this._chips && this._chips.some(chip => chip._hasFocus());
    }
    /** Syncs the chip-set's state with the individual chips. */
    _syncChipsState() {
      this._chips?.forEach(chip => {
        chip._chipListDisabled = this._disabled;
        chip._changeDetectorRef.markForCheck();
      });
    }
    /** Dummy method for subclasses to override. Base chip set cannot be focused. */
    focus() {}
    /** Handles keyboard events on the chip set. */
    _handleKeydown(event) {
      if (this._originatesFromChip(event)) {
        this._keyManager.onKeydown(event);
      }
    }
    /**
     * Utility to ensure all indexes are valid.
     *
     * @param index The index to be checked.
     * @returns True if the index is valid for our list of chips.
     */
    _isValidIndex(index) {
      return index >= 0 && index < this._chips.length;
    }
    /**
     * Removes the `tabindex` from the chip set and resets it back afterwards, allowing the
     * user to tab out of it. This prevents the set from capturing focus and redirecting
     * it back to the first chip, creating a focus trap, if it user tries to tab away.
     */
    _allowFocusEscape() {
      const previous = this._elementRef.nativeElement.tabIndex;
      if (previous !== -1) {
        // Set the tabindex directly on the element, instead of going through
        // the data binding, because we aren't guaranteed that change detection
        // will run quickly enough to allow focus to escape.
        this._elementRef.nativeElement.tabIndex = -1;
        // Note that this needs to be a `setTimeout`, because a `Promise.resolve`
        // doesn't allow enough time for the focus to escape.
        setTimeout(() => this._elementRef.nativeElement.tabIndex = previous);
      }
    }
    /**
     * Gets a stream of events from all the chips within the set.
     * The stream will automatically incorporate any newly-added chips.
     */
    _getChipStream(mappingFunction) {
      return this._chips.changes.pipe(startWith(null), switchMap(() => merge(...this._chips.map(mappingFunction))));
    }
    /** Checks whether an event comes from inside a chip element. */
    _originatesFromChip(event) {
      let currentElement = event.target;
      while (currentElement && currentElement !== this._elementRef.nativeElement) {
        if (currentElement.classList.contains('mat-mdc-chip')) {
          return true;
        }
        currentElement = currentElement.parentElement;
      }
      return false;
    }
    /** Sets up the chip set's focus management logic. */
    _setUpFocusManagement() {
      // Create a flat `QueryList` containing the actions of all of the chips.
      // This allows us to navigate both within the chip and move to the next/previous
      // one using the existing `ListKeyManager`.
      this._chips.changes.pipe(startWith(this._chips)).subscribe(chips => {
        const actions = [];
        chips.forEach(chip => chip._getActions().forEach(action => actions.push(action)));
        this._chipActions.reset(actions);
        this._chipActions.notifyOnChanges();
      });
      this._keyManager = new FocusKeyManager(this._chipActions).withVerticalOrientation().withHorizontalOrientation(this._dir ? this._dir.value : 'ltr').withHomeAndEnd().skipPredicate(action => this._skipPredicate(action));
      // Keep the manager active index in sync so that navigation picks
      // up from the current chip if the user clicks into the list directly.
      this.chipFocusChanges.pipe(takeUntil(this._destroyed)).subscribe(({
        chip
      }) => {
        const action = chip._getSourceAction(document.activeElement);
        if (action) {
          this._keyManager.updateActiveItem(action);
        }
      });
      this._dir?.change.pipe(takeUntil(this._destroyed)).subscribe(direction => this._keyManager.withHorizontalOrientation(direction));
    }
    /**
     * Determines if key manager should avoid putting a given chip action in the tab index. Skip
     * non-interactive and disabled actions since the user can't do anything with them.
     */
    _skipPredicate(action) {
      // Skip chips that the user cannot interact with. `mat-chip-set` does not permit focusing disabled
      // chips.
      return !action.isInteractive || action.disabled;
    }
    /** Listens to changes in the chip set and syncs up the state of the individual chips. */
    _trackChipSetChanges() {
      this._chips.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
        if (this.disabled) {
          // Since this happens after the content has been
          // checked, we need to defer it to the next tick.
          Promise.resolve().then(() => this._syncChipsState());
        }
        this._redirectDestroyedChipFocus();
      });
    }
    /** Starts tracking the destroyed chips in order to capture the focused one. */
    _trackDestroyedFocusedChip() {
      this.chipDestroyedChanges.pipe(takeUntil(this._destroyed)).subscribe(event => {
        const chipArray = this._chips.toArray();
        const chipIndex = chipArray.indexOf(event.chip);
        // If the focused chip is destroyed, save its index so that we can move focus to the next
        // chip. We only save the index here, rather than move the focus immediately, because we want
        // to wait until the chip is removed from the chip list before focusing the next one. This
        // allows us to keep focus on the same index if the chip gets swapped out.
        if (this._isValidIndex(chipIndex) && event.chip._hasFocus()) {
          this._lastDestroyedFocusedChipIndex = chipIndex;
        }
      });
    }
    /**
     * Finds the next appropriate chip to move focus to,
     * if the currently-focused chip is destroyed.
     */
    _redirectDestroyedChipFocus() {
      if (this._lastDestroyedFocusedChipIndex == null) {
        return;
      }
      if (this._chips.length) {
        const newIndex = Math.min(this._lastDestroyedFocusedChipIndex, this._chips.length - 1);
        const chipToFocus = this._chips.toArray()[newIndex];
        if (chipToFocus.disabled) {
          // If we're down to one disabled chip, move focus back to the set.
          if (this._chips.length === 1) {
            this.focus();
          } else {
            this._keyManager.setPreviousItemActive();
          }
        } else {
          chipToFocus.focus();
        }
      } else {
        this.focus();
      }
      this._lastDestroyedFocusedChipIndex = null;
    }
    static ɵfac = function MatChipSet_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipSet)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipSet,
      selectors: [["mat-chip-set"]],
      contentQueries: function MatChipSet_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChip, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._chips = _t);
        }
      },
      hostAttrs: [1, "mat-mdc-chip-set", "mdc-evolution-chip-set"],
      hostVars: 1,
      hostBindings: function MatChipSet_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MatChipSet_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        role: "role",
        tabIndex: [2, "tabIndex", "tabIndex", value => value == null ? 0 : numberAttribute(value)]
      },
      features: [i0.ɵɵInputTransformsFeature],
      ngContentSelectors: _c5,
      decls: 2,
      vars: 0,
      consts: [["role", "presentation", 1, "mdc-evolution-chip-set__chips"]],
      template: function MatChipSet_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: [".mat-mdc-chip-set{display:flex}.mat-mdc-chip-set:focus{outline:none}.mat-mdc-chip-set .mdc-evolution-chip-set__chips{min-width:100%;margin-left:-8px;margin-right:0}.mat-mdc-chip-set .mdc-evolution-chip{margin:4px 0 4px 8px}[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip-set__chips{margin-left:0;margin-right:-8px}[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip{margin-left:0;margin-right:8px}.mdc-evolution-chip-set__chips{display:flex;flex-flow:wrap;min-width:0}.mat-mdc-chip-set-stacked{flex-direction:column;align-items:flex-start}.mat-mdc-chip-set-stacked .mat-mdc-chip{width:100%}.mat-mdc-chip-set-stacked .mdc-evolution-chip__graphic{flex-grow:0}.mat-mdc-chip-set-stacked .mdc-evolution-chip__action--primary{flex-basis:100%;justify-content:start}input.mat-mdc-chip-input{flex:1 0 150px;margin-left:8px}[dir=rtl] input.mat-mdc-chip-input{margin-left:0;margin-right:8px}"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatChipSet;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Change event object that is emitted when the chip listbox value has changed. */
class MatChipListboxChange {
  source;
  value;
  constructor(/** Chip listbox that emitted the event. */
  source, /** Value of the chip listbox when the event was emitted. */
  value) {
    this.source = source;
    this.value = value;
  }
}
/**
 * Provider Expression that allows mat-chip-listbox to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 * @docs-private
 */
const MAT_CHIP_LISTBOX_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*#__PURE__*/forwardRef(() => MatChipListbox),
  multi: true
};
/**
 * An extension of the MatChipSet component that supports chip selection.
 * Used with MatChipOption chips.
 */
let MatChipListbox = /*#__PURE__*/(() => {
  class MatChipListbox extends MatChipSet {
    /**
     * Function when touched. Set as part of ControlValueAccessor implementation.
     * @docs-private
     */
    _onTouched = () => {};
    /**
     * Function when changed. Set as part of ControlValueAccessor implementation.
     * @docs-private
     */
    _onChange = () => {};
    // TODO: MDC uses `grid` here
    _defaultRole = 'listbox';
    /** Value that was assigned before the listbox was initialized. */
    _pendingInitialValue;
    /** Default chip options. */
    _defaultOptions = inject(MAT_CHIPS_DEFAULT_OPTIONS, {
      optional: true
    });
    /** Whether the user should be allowed to select multiple chips. */
    get multiple() {
      return this._multiple;
    }
    set multiple(value) {
      this._multiple = value;
      this._syncListboxProperties();
    }
    _multiple = false;
    /** The array of selected chips inside the chip listbox. */
    get selected() {
      const selectedChips = this._chips.toArray().filter(chip => chip.selected);
      return this.multiple ? selectedChips : selectedChips[0];
    }
    /** Orientation of the chip list. */
    ariaOrientation = 'horizontal';
    /**
     * Whether or not this chip listbox is selectable.
     *
     * When a chip listbox is not selectable, the selected states for all
     * the chips inside the chip listbox are always ignored.
     */
    get selectable() {
      return this._selectable;
    }
    set selectable(value) {
      this._selectable = value;
      this._syncListboxProperties();
    }
    _selectable = true;
    /**
     * A function to compare the option values with the selected values. The first argument
     * is a value from an option. The second is a value from the selection. A boolean
     * should be returned.
     */
    compareWith = (o1, o2) => o1 === o2;
    /** Whether this chip listbox is required. */
    required = false;
    /** Whether checkmark indicator for single-selection options is hidden. */
    get hideSingleSelectionIndicator() {
      return this._hideSingleSelectionIndicator;
    }
    set hideSingleSelectionIndicator(value) {
      this._hideSingleSelectionIndicator = value;
      this._syncListboxProperties();
    }
    _hideSingleSelectionIndicator = this._defaultOptions?.hideSingleSelectionIndicator ?? false;
    /** Combined stream of all of the child chips' selection change events. */
    get chipSelectionChanges() {
      return this._getChipStream(chip => chip.selectionChange);
    }
    /** Combined stream of all of the child chips' blur events. */
    get chipBlurChanges() {
      return this._getChipStream(chip => chip._onBlur);
    }
    /** The value of the listbox, which is the combined value of the selected chips. */
    get value() {
      return this._value;
    }
    set value(value) {
      this.writeValue(value);
      this._value = value;
    }
    _value;
    /** Event emitted when the selected chip listbox value has been changed by the user. */
    change = new EventEmitter();
    _chips = undefined;
    ngAfterContentInit() {
      if (this._pendingInitialValue !== undefined) {
        Promise.resolve().then(() => {
          this._setSelectionByValue(this._pendingInitialValue, false);
          this._pendingInitialValue = undefined;
        });
      }
      this._chips.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
        // Update listbox selectable/multiple properties on chips
        this._syncListboxProperties();
      });
      this.chipBlurChanges.pipe(takeUntil(this._destroyed)).subscribe(() => this._blur());
      this.chipSelectionChanges.pipe(takeUntil(this._destroyed)).subscribe(event => {
        if (!this.multiple) {
          this._chips.forEach(chip => {
            if (chip !== event.source) {
              chip._setSelectedState(false, false, false);
            }
          });
        }
        if (event.isUserInput) {
          this._propagateChanges();
        }
      });
    }
    /**
     * Focuses the first selected chip in this chip listbox, or the first non-disabled chip when there
     * are no selected chips.
     */
    focus() {
      if (this.disabled) {
        return;
      }
      const firstSelectedChip = this._getFirstSelectedChip();
      if (firstSelectedChip && !firstSelectedChip.disabled) {
        firstSelectedChip.focus();
      } else if (this._chips.length > 0) {
        this._keyManager.setFirstItemActive();
      } else {
        this._elementRef.nativeElement.focus();
      }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    writeValue(value) {
      if (this._chips) {
        this._setSelectionByValue(value, false);
      } else if (value != null) {
        this._pendingInitialValue = value;
      }
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    registerOnChange(fn) {
      this._onChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    /** Selects all chips with value. */
    _setSelectionByValue(value, isUserInput = true) {
      this._clearSelection();
      if (Array.isArray(value)) {
        value.forEach(currentValue => this._selectValue(currentValue, isUserInput));
      } else {
        this._selectValue(value, isUserInput);
      }
    }
    /** When blurred, marks the field as touched when focus moved outside the chip listbox. */
    _blur() {
      if (!this.disabled) {
        // Wait to see if focus moves to an individual chip.
        setTimeout(() => {
          if (!this.focused) {
            this._markAsTouched();
          }
        });
      }
    }
    _keydown(event) {
      if (event.keyCode === TAB) {
        super._allowFocusEscape();
      }
    }
    /** Marks the field as touched */
    _markAsTouched() {
      this._onTouched();
      this._changeDetectorRef.markForCheck();
    }
    /** Emits change event to set the model value. */
    _propagateChanges() {
      let valueToEmit = null;
      if (Array.isArray(this.selected)) {
        valueToEmit = this.selected.map(chip => chip.value);
      } else {
        valueToEmit = this.selected ? this.selected.value : undefined;
      }
      this._value = valueToEmit;
      this.change.emit(new MatChipListboxChange(this, valueToEmit));
      this._onChange(valueToEmit);
      this._changeDetectorRef.markForCheck();
    }
    /**
     * Deselects every chip in the listbox.
     * @param skip Chip that should not be deselected.
     */
    _clearSelection(skip) {
      this._chips.forEach(chip => {
        if (chip !== skip) {
          chip.deselect();
        }
      });
    }
    /**
     * Finds and selects the chip based on its value.
     * @returns Chip that has the corresponding value.
     */
    _selectValue(value, isUserInput) {
      const correspondingChip = this._chips.find(chip => {
        return chip.value != null && this.compareWith(chip.value, value);
      });
      if (correspondingChip) {
        isUserInput ? correspondingChip.selectViaInteraction() : correspondingChip.select();
      }
      return correspondingChip;
    }
    /** Syncs the chip-listbox selection state with the individual chips. */
    _syncListboxProperties() {
      if (this._chips) {
        // Defer setting the value in order to avoid the "Expression
        // has changed after it was checked" errors from Angular.
        Promise.resolve().then(() => {
          this._chips.forEach(chip => {
            chip._chipListMultiple = this.multiple;
            chip.chipListSelectable = this._selectable;
            chip._chipListHideSingleSelectionIndicator = this.hideSingleSelectionIndicator;
            chip._changeDetectorRef.markForCheck();
          });
        });
      }
    }
    /** Returns the first selected chip in this listbox, or undefined if no chips are selected. */
    _getFirstSelectedChip() {
      if (Array.isArray(this.selected)) {
        return this.selected.length ? this.selected[0] : undefined;
      } else {
        return this.selected;
      }
    }
    /**
     * Determines if key manager should avoid putting a given chip action in the tab index. Skip
     * non-interactive actions since the user can't do anything with them.
     */
    _skipPredicate(action) {
      // Override the skip predicate in the base class to avoid skipping disabled chips. Allow
      // disabled chip options to receive focus to align with WAI ARIA recommendation. Normally WAI
      // ARIA's instructions are to exclude disabled items from the tab order, but it makes a few
      // exceptions for compound widgets.
      //
      // From [Developing a Keyboard Interface](
      // https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/):
      //   "For the following composite widget elements, keep them focusable when disabled: Options in a
      //   Listbox..."
      return !action.isInteractive;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipListbox_BaseFactory;
      return function MatChipListbox_Factory(__ngFactoryType__) {
        return (ɵMatChipListbox_BaseFactory || (ɵMatChipListbox_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipListbox)))(__ngFactoryType__ || MatChipListbox);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipListbox,
      selectors: [["mat-chip-listbox"]],
      contentQueries: function MatChipListbox_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChipOption, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._chips = _t);
        }
      },
      hostAttrs: [1, "mdc-evolution-chip-set", "mat-mdc-chip-listbox"],
      hostVars: 11,
      hostBindings: function MatChipListbox_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatChipListbox_focus_HostBindingHandler() {
            return ctx.focus();
          })("blur", function MatChipListbox_blur_HostBindingHandler() {
            return ctx._blur();
          })("keydown", function MatChipListbox_keydown_HostBindingHandler($event) {
            return ctx._keydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("tabIndex", ctx.disabled || ctx.empty ? -1 : ctx.tabIndex);
          i0.ɵɵattribute("role", ctx.role)("aria-describedby", ctx._ariaDescribedby || null)("aria-required", ctx.role ? ctx.required : null)("aria-disabled", ctx.disabled.toString())("aria-multiselectable", ctx.multiple)("aria-orientation", ctx.ariaOrientation);
          i0.ɵɵclassProp("mat-mdc-chip-list-disabled", ctx.disabled)("mat-mdc-chip-list-required", ctx.required);
        }
      },
      inputs: {
        multiple: [2, "multiple", "multiple", booleanAttribute],
        ariaOrientation: [0, "aria-orientation", "ariaOrientation"],
        selectable: [2, "selectable", "selectable", booleanAttribute],
        compareWith: "compareWith",
        required: [2, "required", "required", booleanAttribute],
        hideSingleSelectionIndicator: [2, "hideSingleSelectionIndicator", "hideSingleSelectionIndicator", booleanAttribute],
        value: "value"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([MAT_CHIP_LISTBOX_CONTROL_VALUE_ACCESSOR]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c5,
      decls: 2,
      vars: 0,
      consts: [["role", "presentation", 1, "mdc-evolution-chip-set__chips"]],
      template: function MatChipListbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: [_c6],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatChipListbox;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Change event object that is emitted when the chip grid value has changed. */
class MatChipGridChange {
  source;
  value;
  constructor(/** Chip grid that emitted the event. */
  source, /** Value of the chip grid when the event was emitted. */
  value) {
    this.source = source;
    this.value = value;
  }
}
/**
 * An extension of the MatChipSet component used with MatChipRow chips and
 * the matChipInputFor directive.
 */
let MatChipGrid = /*#__PURE__*/(() => {
  class MatChipGrid extends MatChipSet {
    ngControl = inject(NgControl, {
      optional: true,
      self: true
    });
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    controlType = 'mat-chip-grid';
    /** The chip input to add more chips */
    _chipInput;
    _defaultRole = 'grid';
    _errorStateTracker;
    /**
     * List of element ids to propagate to the chipInput's aria-describedby attribute.
     */
    _ariaDescribedbyIds = [];
    /**
     * Function when touched. Set as part of ControlValueAccessor implementation.
     * @docs-private
     */
    _onTouched = () => {};
    /**
     * Function when changed. Set as part of ControlValueAccessor implementation.
     * @docs-private
     */
    _onChange = () => {};
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get disabled() {
      return this.ngControl ? !!this.ngControl.disabled : this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
      this._syncChipsState();
      this.stateChanges.next();
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get id() {
      return this._chipInput.id;
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get empty() {
      return (!this._chipInput || this._chipInput.empty) && (!this._chips || this._chips.length === 0);
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get placeholder() {
      return this._chipInput ? this._chipInput.placeholder : this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    _placeholder;
    /** Whether any chips or the matChipInput inside of this chip-grid has focus. */
    get focused() {
      return this._chipInput.focused || this._hasFocusedChip();
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get required() {
      return this._required ?? this.ngControl?.control?.hasValidator(Validators.required) ?? false;
    }
    set required(value) {
      this._required = value;
      this.stateChanges.next();
    }
    _required;
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get shouldLabelFloat() {
      return !this.empty || this.focused;
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get value() {
      return this._value;
    }
    set value(value) {
      this._value = value;
    }
    _value = [];
    /** An object used to control when error messages are shown. */
    get errorStateMatcher() {
      return this._errorStateTracker.matcher;
    }
    set errorStateMatcher(value) {
      this._errorStateTracker.matcher = value;
    }
    /** Combined stream of all of the child chips' blur events. */
    get chipBlurChanges() {
      return this._getChipStream(chip => chip._onBlur);
    }
    /** Emits when the chip grid value has been changed by the user. */
    change = new EventEmitter();
    /**
     * Emits whenever the raw value of the chip-grid changes. This is here primarily
     * to facilitate the two-way binding for the `value` input.
     * @docs-private
     */
    valueChange = new EventEmitter();
    _chips = undefined;
    /**
     * Emits whenever the component state changes and should cause the parent
     * form-field to update. Implemented as part of `MatFormFieldControl`.
     * @docs-private
     */
    stateChanges = new Subject();
    /** Whether the chip grid is in an error state. */
    get errorState() {
      return this._errorStateTracker.errorState;
    }
    set errorState(value) {
      this._errorStateTracker.errorState = value;
    }
    constructor() {
      super();
      const parentForm = inject(NgForm, {
        optional: true
      });
      const parentFormGroup = inject(FormGroupDirective, {
        optional: true
      });
      const defaultErrorStateMatcher = inject(ErrorStateMatcher);
      if (this.ngControl) {
        this.ngControl.valueAccessor = this;
      }
      this._errorStateTracker = new _ErrorStateTracker(defaultErrorStateMatcher, this.ngControl, parentFormGroup, parentForm, this.stateChanges);
    }
    ngAfterContentInit() {
      this.chipBlurChanges.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._blur();
        this.stateChanges.next();
      });
      merge(this.chipFocusChanges, this._chips.changes).pipe(takeUntil(this._destroyed)).subscribe(() => this.stateChanges.next());
    }
    ngAfterViewInit() {
      super.ngAfterViewInit();
      if (!this._chipInput && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw Error('mat-chip-grid must be used in combination with matChipInputFor.');
      }
    }
    ngDoCheck() {
      if (this.ngControl) {
        // We need to re-evaluate this on every change detection cycle, because there are some
        // error triggers that we can't subscribe to (e.g. parent form submissions). This means
        // that whatever logic is in here has to be super lean or we risk destroying the performance.
        this.updateErrorState();
      }
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this.stateChanges.complete();
    }
    /** Associates an HTML input element with this chip grid. */
    registerInput(inputElement) {
      this._chipInput = inputElement;
      this._chipInput.setDescribedByIds(this._ariaDescribedbyIds);
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    onContainerClick(event) {
      if (!this.disabled && !this._originatesFromChip(event)) {
        this.focus();
      }
    }
    /**
     * Focuses the first chip in this chip grid, or the associated input when there
     * are no eligible chips.
     */
    focus() {
      if (this.disabled || this._chipInput.focused) {
        return;
      }
      if (!this._chips.length || this._chips.first.disabled) {
        // Delay until the next tick, because this can cause a "changed after checked"
        // error if the input does something on focus (e.g. opens an autocomplete).
        Promise.resolve().then(() => this._chipInput.focus());
      } else {
        const activeItem = this._keyManager.activeItem;
        if (activeItem) {
          activeItem.focus();
        } else {
          this._keyManager.setFirstItemActive();
        }
      }
      this.stateChanges.next();
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    setDescribedByIds(ids) {
      // We must keep this up to date to handle the case where ids are set
      // before the chip input is registered.
      this._ariaDescribedbyIds = ids;
      this._chipInput?.setDescribedByIds(ids);
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    writeValue(value) {
      // The user is responsible for creating the child chips, so we just store the value.
      this._value = value;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    registerOnChange(fn) {
      this._onChange = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    /**
     * Implemented as part of ControlValueAccessor.
     * @docs-private
     */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
      this.stateChanges.next();
    }
    /** Refreshes the error state of the chip grid. */
    updateErrorState() {
      this._errorStateTracker.updateErrorState();
    }
    /** When blurred, mark the field as touched when focus moved outside the chip grid. */
    _blur() {
      if (!this.disabled) {
        // Check whether the focus moved to chip input.
        // If the focus is not moved to chip input, mark the field as touched. If the focus moved
        // to chip input, do nothing.
        // Timeout is needed to wait for the focus() event trigger on chip input.
        setTimeout(() => {
          if (!this.focused) {
            this._propagateChanges();
            this._markAsTouched();
          }
        });
      }
    }
    /**
     * Removes the `tabindex` from the chip grid and resets it back afterwards, allowing the
     * user to tab out of it. This prevents the grid from capturing focus and redirecting
     * it back to the first chip, creating a focus trap, if it user tries to tab away.
     */
    _allowFocusEscape() {
      if (!this._chipInput.focused) {
        super._allowFocusEscape();
      }
    }
    /** Handles custom keyboard events. */
    _handleKeydown(event) {
      const keyCode = event.keyCode;
      const activeItem = this._keyManager.activeItem;
      if (keyCode === TAB) {
        if (this._chipInput.focused && hasModifierKey(event, 'shiftKey') && this._chips.length && !this._chips.last.disabled) {
          event.preventDefault();
          if (activeItem) {
            this._keyManager.setActiveItem(activeItem);
          } else {
            this._focusLastChip();
          }
        } else {
          // Use the super method here since it doesn't check for the input
          // focused state. This allows focus to escape if there's only one
          // disabled chip left in the list.
          super._allowFocusEscape();
        }
      } else if (!this._chipInput.focused) {
        // The up and down arrows are supposed to navigate between the individual rows in the grid.
        // We do this by filtering the actions down to the ones that have the same `_isPrimary`
        // flag as the active action and moving focus between them ourseles instead of delegating
        // to the key manager. For more information, see #29359 and:
        // https://www.w3.org/WAI/ARIA/apg/patterns/grid/examples/layout-grids/#ex2_label
        if ((keyCode === UP_ARROW || keyCode === DOWN_ARROW) && activeItem) {
          const eligibleActions = this._chipActions.filter(action => action._isPrimary === activeItem._isPrimary && !this._skipPredicate(action));
          const currentIndex = eligibleActions.indexOf(activeItem);
          const delta = event.keyCode === UP_ARROW ? -1 : 1;
          event.preventDefault();
          if (currentIndex > -1 && this._isValidIndex(currentIndex + delta)) {
            this._keyManager.setActiveItem(eligibleActions[currentIndex + delta]);
          }
        } else {
          super._handleKeydown(event);
        }
      }
      this.stateChanges.next();
    }
    _focusLastChip() {
      if (this._chips.length) {
        this._chips.last.focus();
      }
    }
    /** Emits change event to set the model value. */
    _propagateChanges() {
      const valueToEmit = this._chips.length ? this._chips.toArray().map(chip => chip.value) : [];
      this._value = valueToEmit;
      this.change.emit(new MatChipGridChange(this, valueToEmit));
      this.valueChange.emit(valueToEmit);
      this._onChange(valueToEmit);
      this._changeDetectorRef.markForCheck();
    }
    /** Mark the field as touched */
    _markAsTouched() {
      this._onTouched();
      this._changeDetectorRef.markForCheck();
      this.stateChanges.next();
    }
    static ɵfac = function MatChipGrid_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipGrid)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipGrid,
      selectors: [["mat-chip-grid"]],
      contentQueries: function MatChipGrid_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChipRow, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._chips = _t);
        }
      },
      hostAttrs: [1, "mat-mdc-chip-set", "mat-mdc-chip-grid", "mdc-evolution-chip-set"],
      hostVars: 10,
      hostBindings: function MatChipGrid_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatChipGrid_focus_HostBindingHandler() {
            return ctx.focus();
          })("blur", function MatChipGrid_blur_HostBindingHandler() {
            return ctx._blur();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role)("tabindex", ctx.disabled || ctx._chips && ctx._chips.length === 0 ? -1 : ctx.tabIndex)("aria-disabled", ctx.disabled.toString())("aria-invalid", ctx.errorState);
          i0.ɵɵclassProp("mat-mdc-chip-list-disabled", ctx.disabled)("mat-mdc-chip-list-invalid", ctx.errorState)("mat-mdc-chip-list-required", ctx.required);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        placeholder: "placeholder",
        required: [2, "required", "required", booleanAttribute],
        value: "value",
        errorStateMatcher: "errorStateMatcher"
      },
      outputs: {
        change: "change",
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatFormFieldControl,
        useExisting: MatChipGrid
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c5,
      decls: 2,
      vars: 0,
      consts: [["role", "presentation", 1, "mdc-evolution-chip-set__chips"]],
      template: function MatChipGrid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: [_c6],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatChipGrid;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Directive that adds chip-specific behaviors to an input element inside `<mat-form-field>`.
 * May be placed inside or outside of a `<mat-chip-grid>`.
 */
let MatChipInput = /*#__PURE__*/(() => {
  class MatChipInput {
    _elementRef = inject(ElementRef);
    /** Whether the control is focused. */
    focused = false;
    /** Register input for chip list */
    get chipGrid() {
      return this._chipGrid;
    }
    set chipGrid(value) {
      if (value) {
        this._chipGrid = value;
        this._chipGrid.registerInput(this);
      }
    }
    _chipGrid;
    /**
     * Whether or not the chipEnd event will be emitted when the input is blurred.
     */
    addOnBlur = false;
    /**
     * The list of key codes that will trigger a chipEnd event.
     *
     * Defaults to `[ENTER]`.
     */
    separatorKeyCodes;
    /** Emitted when a chip is to be added. */
    chipEnd = new EventEmitter();
    /** The input's placeholder text. */
    placeholder = '';
    /** Unique id for the input. */
    id = inject(_IdGenerator).getId('mat-mdc-chip-list-input-');
    /** Whether the input is disabled. */
    get disabled() {
      return this._disabled || this._chipGrid && this._chipGrid.disabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled = false;
    /** Whether the input is empty. */
    get empty() {
      return !this.inputElement.value;
    }
    /** The native input element to which this directive is attached. */
    inputElement;
    constructor() {
      const defaultOptions = inject(MAT_CHIPS_DEFAULT_OPTIONS);
      const formField = inject(MAT_FORM_FIELD, {
        optional: true
      });
      this.inputElement = this._elementRef.nativeElement;
      this.separatorKeyCodes = defaultOptions.separatorKeyCodes;
      if (formField) {
        this.inputElement.classList.add('mat-mdc-form-field-input-control');
      }
    }
    ngOnChanges() {
      this._chipGrid.stateChanges.next();
    }
    ngOnDestroy() {
      this.chipEnd.complete();
    }
    /** Utility method to make host definition/tests more clear. */
    _keydown(event) {
      if (this.empty && event.keyCode === BACKSPACE) {
        // Ignore events where the user is holding down backspace
        // so that we don't accidentally remove too many chips.
        if (!event.repeat) {
          this._chipGrid._focusLastChip();
        }
        event.preventDefault();
      } else {
        this._emitChipEnd(event);
      }
    }
    /** Checks to see if the blur should emit the (chipEnd) event. */
    _blur() {
      if (this.addOnBlur) {
        this._emitChipEnd();
      }
      this.focused = false;
      // Blur the chip list if it is not focused
      if (!this._chipGrid.focused) {
        this._chipGrid._blur();
      }
      this._chipGrid.stateChanges.next();
    }
    _focus() {
      this.focused = true;
      this._chipGrid.stateChanges.next();
    }
    /** Checks to see if the (chipEnd) event needs to be emitted. */
    _emitChipEnd(event) {
      if (!event || this._isSeparatorKey(event) && !event.repeat) {
        this.chipEnd.emit({
          input: this.inputElement,
          value: this.inputElement.value,
          chipInput: this
        });
        event?.preventDefault();
      }
    }
    _onInput() {
      // Let chip list know whenever the value changes.
      this._chipGrid.stateChanges.next();
    }
    /** Focuses the input. */
    focus() {
      this.inputElement.focus();
    }
    /** Clears the input */
    clear() {
      this.inputElement.value = '';
    }
    setDescribedByIds(ids) {
      const element = this._elementRef.nativeElement;
      // Set the value directly in the DOM since this binding
      // is prone to "changed after checked" errors.
      if (ids.length) {
        element.setAttribute('aria-describedby', ids.join(' '));
      } else {
        element.removeAttribute('aria-describedby');
      }
    }
    /** Checks whether a keycode is one of the configured separators. */
    _isSeparatorKey(event) {
      return !hasModifierKey(event) && new Set(this.separatorKeyCodes).has(event.keyCode);
    }
    static ɵfac = function MatChipInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipInput)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipInput,
      selectors: [["input", "matChipInputFor", ""]],
      hostAttrs: [1, "mat-mdc-chip-input", "mat-mdc-input-element", "mdc-text-field__input", "mat-input-element"],
      hostVars: 6,
      hostBindings: function MatChipInput_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MatChipInput_keydown_HostBindingHandler($event) {
            return ctx._keydown($event);
          })("blur", function MatChipInput_blur_HostBindingHandler() {
            return ctx._blur();
          })("focus", function MatChipInput_focus_HostBindingHandler() {
            return ctx._focus();
          })("input", function MatChipInput_input_HostBindingHandler() {
            return ctx._onInput();
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id);
          i0.ɵɵattribute("disabled", ctx.disabled || null)("placeholder", ctx.placeholder || null)("aria-invalid", ctx._chipGrid && ctx._chipGrid.ngControl ? ctx._chipGrid.ngControl.invalid : null)("aria-required", ctx._chipGrid && ctx._chipGrid.required || null)("required", ctx._chipGrid && ctx._chipGrid.required || null);
        }
      },
      inputs: {
        chipGrid: [0, "matChipInputFor", "chipGrid"],
        addOnBlur: [2, "matChipInputAddOnBlur", "addOnBlur", booleanAttribute],
        separatorKeyCodes: [0, "matChipInputSeparatorKeyCodes", "separatorKeyCodes"],
        placeholder: "placeholder",
        id: "id",
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        chipEnd: "matChipInputTokenEnd"
      },
      exportAs: ["matChipInput", "matChipInputFor"],
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
  return MatChipInput;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CHIP_DECLARATIONS = [MatChip, MatChipAvatar, MatChipEditInput, MatChipGrid, MatChipInput, MatChipListbox, MatChipOption, MatChipRemove, MatChipRow, MatChipSet, MatChipTrailingIcon];
let MatChipsModule = /*#__PURE__*/(() => {
  class MatChipsModule {
    static ɵfac = function MatChipsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatChipsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ErrorStateMatcher, {
        provide: MAT_CHIPS_DEFAULT_OPTIONS,
        useValue: {
          separatorKeyCodes: [ENTER]
        }
      }],
      imports: [MatCommonModule, MatRippleModule, MatCommonModule]
    });
  }
  return MatChipsModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MAT_CHIP, MAT_CHIPS_DEFAULT_OPTIONS, MAT_CHIP_AVATAR, MAT_CHIP_LISTBOX_CONTROL_VALUE_ACCESSOR, MAT_CHIP_REMOVE, MAT_CHIP_TRAILING_ICON, MatChip, MatChipAvatar, MatChipEditInput, MatChipGrid, MatChipGridChange, MatChipInput, MatChipListbox, MatChipListboxChange, MatChipOption, MatChipRemove, MatChipRow, MatChipSelectionChange, MatChipSet, MatChipTrailingIcon, MatChipsModule };
